import { createFileRoute } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';

import { UserGroupsTable } from '~/components/settings/masterData/userGroup/UserGroupsTable';

import { routeParams, validateSearch } from './-routeParams';

export const Route = createFileRoute(
  '/(main)/settings/masterdata/user-groups/',
)({
  beforeLoad: createProtectedRoute({
    routePath: '/settings/masterdata/user-groups',
    ...routeParams,
  }),
  component: UserGroupsTable,
  validateSearch,
});

export const MASTERDATA_USER_GROUPS = buildRouteExport({
  Route,
  ...routeParams,
});
